import { render } from "./EmployeeShiftPermissionsList.vue?vue&type=template&id=34c2f8e4&scoped=true"
import script from "./EmployeeShiftPermissionsList.vue?vue&type=script&lang=js"
export * from "./EmployeeShiftPermissionsList.vue?vue&type=script&lang=js"

import "./EmployeeShiftPermissionsList.vue?vue&type=style&index=0&id=34c2f8e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c2f8e4"]])

export default __exports__